import { useState, useContext } from 'react'
import { Link } from 'react-router-dom'
import { FiLogIn } from 'react-icons/fi'

import Input from '../../shared/components/form/Input'
import { Context } from '../../context/UserContext'

import './auth.css'

function Login() {
    const [user, setUser] = useState({})
    const [loading, setLoading] = useState(false)
    const [showResend, setShowResend] = useState(false)
    const { login, resendVerification } = useContext(Context)

    function handleChange(e) {
        setUser({ ...user, [e.target.name]: e.target.value })
        setShowResend(false)
    }

    async function handleSubmit(e) {
        e.preventDefault()
        setLoading(true)
        const { errorCode } = await login(user)
        setShowResend(errorCode === 'EMAIL_NOT_VERIFIED')
        setLoading(false)
    }

    function handleResend() {
        resendVerification(user.email)
        setShowResend(false)
    }

    return (
        <div className="auth">
            <div className="auth-box panel">
                <p className="auth-eyebrow">Acesso à arena</p>
                <h1 className="auth-title">Entrar</h1>
                <p className="auth-subtitle">Entre com sua conta para ver seu perfil e sua posição no ranking.</p>

                <form onSubmit={handleSubmit} className="auth-form">
                    <Input
                        text="Email"
                        type="email"
                        name="email"
                        placeholder="seu@email.com"
                        handleOnChange={handleChange}
                        value={user.email || ''}
                    />
                    <Input
                        text="Senha"
                        type="password"
                        name="password"
                        placeholder="Sua senha"
                        handleOnChange={handleChange}
                        value={user.password || ''}
                    />

                    <button className="btn-primary auth-submit" type="submit" disabled={loading}>
                        <FiLogIn size={16} />
                        {loading ? 'Entrando...' : 'Entrar'}
                    </button>
                </form>

                {showResend && (
                    <button type="button" className="auth-resend" onClick={handleResend}>
                        Reenviar email de confirmação
                    </button>
                )}

                <p className="auth-switch">
                    <Link to="/esqueci-senha">Esqueci minha senha</Link>
                </p>
                <p className="auth-switch">
                    Ainda não tem conta? <Link to="/cadastro">Cadastre-se</Link>
                </p>
            </div>
        </div>
    )
}

export default Login
